import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const Icon: React.FC<SvgProps> = (props) => {
  const { width, height } = props
  return (
    <Svg width={width || '16'} height={height || '18'} viewBox="0 0 16 18" fill="none" {...props}>
      <g id="ARBITRUM_Primary_Logomark_RGB 1" clipPath="url(#clip0_11324_20334)">
        <path
          id="Vector"
          d="M0.603699 5.45496V12.4911C0.603699 12.9375 0.84178 13.3541 1.23291 13.5752L7.32099 17.0912C7.70787 17.3165 8.18828 17.3165 8.57517 17.0912L14.6675 13.5752C15.0544 13.3499 15.2967 12.9375 15.2967 12.4911V5.45496C15.2967 5.00855 15.0586 4.59191 14.6675 4.36658L8.57517 0.850636C8.18828 0.625309 7.70787 0.625309 7.32099 0.850636L1.22866 4.36658C0.846031 4.59191 0.603699 5.0043 0.603699 5.45496Z"
          fill="#213147"
        />
        <g id="Group">
          <path
            id="Vector_2"
            d="M9.28088 10.3357L8.40933 12.7165C8.38382 12.7803 8.38382 12.8568 8.40933 12.9206L9.90159 17.019L11.6319 16.0199L9.55722 10.3315C9.51045 10.2039 9.32764 10.2039 9.28088 10.3357Z"
            fill="#12AAFF"
          />
          <path
            id="Vector_3"
            d="M11.0197 6.32541C10.973 6.19361 10.7901 6.19361 10.7391 6.32541L9.86758 8.70622C9.84207 8.77424 9.84207 8.84652 9.86758 8.91029L12.3164 15.6233L14.0468 14.6242L11.0197 6.32541Z"
            fill="#12AAFF"
          />
        </g>
        <path
          id="Vector_4"
          d="M7.95021 1.10963C7.99273 1.10963 8.03524 1.12238 8.0735 1.14364L14.6633 4.94869C14.7398 4.9912 14.7865 5.07198 14.7865 5.16126V12.7714C14.7865 12.8606 14.7398 12.9414 14.6633 12.9839L8.0735 16.7932C8.03524 16.8145 7.99273 16.8272 7.95021 16.8272C7.9077 16.8272 7.86518 16.8145 7.82692 16.7932L1.23717 12.9882C1.16065 12.9457 1.11388 12.8649 1.11388 12.7756V5.16126C1.11388 5.07198 1.16065 4.9912 1.23717 4.94869L7.82692 1.14364C7.86518 1.12238 7.9077 1.10963 7.95021 1.10963ZM7.95021 0C7.71638 0 7.4783 0.0637718 7.26998 0.182812L0.680232 3.98786C0.26359 4.23019 0 4.6766 0 5.16126V12.7714C0 13.256 0.259338 13.7067 0.680232 13.949L7.26998 17.7541C7.4783 17.8773 7.71213 17.9369 7.95021 17.9369C8.18829 17.9369 8.42212 17.8731 8.63044 17.7541L15.2202 13.949C15.6411 13.7067 15.9004 13.2603 15.9004 12.7714V5.16126C15.9004 4.6766 15.6411 4.22594 15.2202 3.98361L8.63044 0.182812C8.41787 0.0637718 8.18404 0 7.95021 0Z"
          fill="#9DCCED"
        />
        <path
          id="Vector_5"
          d="M3.59247 15.6346L4.20043 13.9766L5.41634 14.9884L4.2812 16.03L3.59247 15.6346Z"
          fill="#213147"
        />
        <g id="Group_2">
          <path
            id="Vector_6"
            d="M7.39326 4.62109H5.72244C5.59915 4.62109 5.48436 4.69762 5.44184 4.81666L1.86212 14.6375L3.59246 15.6366L7.53781 4.82091C7.57182 4.72313 7.49954 4.62109 7.39326 4.62109Z"
            fill="white"
          />
          <path
            id="Vector_7"
            d="M10.3182 4.62109H8.64743C8.52414 4.62109 8.40935 4.69762 8.36683 4.81666L4.28119 16.0277L6.01153 17.0268L10.4585 4.82091C10.4968 4.72313 10.4203 4.62109 10.3182 4.62109Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11324_20334">
          <rect width="15.8962" height="17.9411" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default Icon
